import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
/**
 * MapMarker
 *
 * Renders out a MapMarker icon, an info box, and manages all the state (hover, etc) for it.
 */
// external dependencies

import React, { useState } from 'react';
// components
import { MapInfoBox } from './MapInfoBox';
import { MapMarkerIcon } from './MapMarkerIcon';
export function MapMarker(_ref) {
  var _ref$RenderMapInfoBox = _ref.RenderMapInfoBox,
      RenderMapInfoBox = _ref$RenderMapInfoBox === void 0 ? MapInfoBox : _ref$RenderMapInfoBox,
      _ref$RenderMapMarker = _ref.RenderMapMarker,
      RenderMapMarker = _ref$RenderMapMarker === void 0 ? MapMarkerIcon : _ref$RenderMapMarker,
      $hover = _ref.$hover,
      fillPrimary = _ref.fillPrimary,
      fillSecondary = _ref.fillSecondary,
      zIndex = _ref.zIndex,
      restOfProps = _objectWithoutProperties(_ref, ["RenderMapInfoBox", "RenderMapMarker", "$hover", "fillPrimary", "fillSecondary", "zIndex"]);
  /**
   * Keep track of the pinned state of this marker. If it's pinned, keep the info window open and let the map
   * marker size stay at the large size. In the future you can also act on this flag to add more functionality
   * such as different background color, show more info in an expanded box, or change the underlying marker.
   */


  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isPinned = _useState2[0],
      setIsPinned = _useState2[1];

  var isExpanded = $hover || isPinned;
  var fill = isPinned ? fillSecondary : fillPrimary;
  var innerFill = isPinned ? fillPrimary : fillSecondary;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RenderMapMarker, {
    fill: fill,
    innerFill: innerFill,
    isExpanded: isExpanded,
    onClick: function onClick() {
      return setIsPinned(!isPinned);
    },
    zIndex: zIndex
  }), isExpanded && /*#__PURE__*/React.createElement(RenderMapInfoBox, _extends({
    onClick: function onClick() {
      return setIsPinned(!isPinned);
    }
  }, restOfProps)));
}